// ConsultationFeedback/ConsultationFeedbackPage.tsx
import React, {useEffect, useState} from 'react';
import {axios} from 'Auth/axiosConfig';
import ConsultationFeedbackForm from './ConsultationFeedbackForm';
import {FCCC} from 'WideLayout/Layouts';
import {Message} from 'Core/components/Message';
import {useTheme} from "Theme/ThemeContext";

interface ConsultationFeedbackPageProps {
    consultationId: string | null;
    onClose: () => void;
}

const ConsultationFeedbackPage: React.FC<ConsultationFeedbackPageProps> = ({consultationId, onClose}) => {
    const [saving, setSaving] = useState<boolean>(false);
    const [feedbackData, setFeedbackData] = useState<any>(null);
    const {plt} = useTheme();

    // Загрузка данных консультации и отзыва (если он есть)
    useEffect(() => {
        if (!consultationId) {
            Message.error('Идентификатор консультации отсутствует.');
            onClose();
            return;
        }
        (async () => {
            try {
                // Замените этот GET на нужный вам эндпоинт, который возвращает консультацию с фидбэками
                // Пример: /api/v1/consultations/:id/ (или любой другой)
                const {data} = await axios.get(`/api/v1/consultations/${consultationId}/`);

                // Если в объекте консультации есть массив feedbacks, берем первый (или ищем тот, который принадлежит пользователю)
                if (data && data.feedbacks && data.feedbacks.length > 0) {
                    setFeedbackData(data.feedbacks[0]);
                }
            } catch (error) {
                console.error(error);
            }
        })();
    }, [consultationId, onClose]);

    const handleConfirm = async (
        connectionRating?: number | null,
        consultationRating?: number | null,
        connectionFeedback?: string,
        consultationFeedback?: string,
        dontWantToRate?: boolean,
        skills?: number[] | null
    ) => {
        setSaving(true);
        try {
            console.log('%%%%%%%%%%%%%%%%');
            console.log('%%%%%%%%%%%%%%%%');
            console.log('%%%%%%%%%%%%%%%%');
            console.log(skills);

            // Если отзыв уже существует, то PATCH, иначе POST
            const method = feedbackData ? 'PATCH' : 'POST';
            const requestData = {
                rating_connection: connectionRating,
                rating_consultation: consultationRating,
                feedback_connection: connectionFeedback || undefined,
                feedback_consultation: consultationFeedback || undefined,
                dont_want_to_rate: dontWantToRate,
                skills: skills || [],
            };

            console.log('Отправляем запрос:', {
                method,
                url: `/api/v1/consultations/${consultationId}/feedback/`,
                data: requestData
            });

            const response = await axios({
                method,
                url: `/api/v1/consultations/${consultationId}/feedback/`,
                data: requestData,
            });

            console.log('Ответ сервера:', response.data);
            Message.success(feedbackData ? 'Отзыв обновлен.' : 'Отзыв успешно оставлен.');
            onClose();
        } catch (error: any) {
            console.error('Ошибка при сохранении отзыва:', error.response?.data || error.message);
            return Message.error('Отзыв уже существует');
        } finally {
            setSaving(false);
        }
    };

    return (
        <FCCC h={'100%'} w={'100%'} alignItems={'center'} justifyContent={'center'} g={3}>
            <h3>Оставьте отзыв о консультации</h3>
            <ConsultationFeedbackForm
                onConfirm={handleConfirm}
                onCancel={onClose}
                loading={saving}
                defaultConnectionRating={feedbackData?.rating_connection || null}
                defaultConsultationRating={feedbackData?.rating_consultation || null}
                defaultConnectionFeedback={feedbackData?.feedback_connection || ''}
                defaultConsultationFeedback={feedbackData?.feedback_consultation || ''}
                defaultDontWantToRate={feedbackData?.dont_want_to_rate || false}
                // Передаем массив айдишников навыков, если есть client_request и psychologist_skills
                defaultSkills={
                    feedbackData?.client_request?.psychologist_skills
                        ? feedbackData.client_request.psychologist_skills.map((skill: any) => skill.id)
                        : []
                }
            />
        </FCCC>
    );
};

export default ConsultationFeedbackPage;